export default __webpack_public_path__ + "static/media/users.5ccf086b.png";